export const borderRadius = {
  xxxs: '3px',
  xxs: '4px',
  xs: '6px',
  sm: '8px',
  md: '10px',
  lg: '12px',
} as const;
